export default {
    hasAccountModalTitle1: 'Vous n’avez pas de compte',
    hasAccountModalTitle2: 'Vous avez déjà un compte',
    existingUserText: 'Un compte existe déjà avec cet Email et ce nom. ' +
        'Merci de vous connecter pour déposer votre candidature',
    hasApplication: 'Vous avez déjà une demande en cours et ne pouvez pas effectuer une nouvelle demande',
}